<template>
  <aufgaben-verwaltung-internal :hide-loader="hideLoader" :show-loader="showLoader" ref="internal" v-if="!hasBauhofPosteingang"/>
  <aufgaben-verwaltung-bauhof :hide-loader="hideLoader" :show-loader="showLoader" ref="bauhof" v-else/>
</template>

<script>
import {Redirect_500, Redirect_Login, Server_URL} from "../../shared/utils";
import AufgabenVerwaltungInternal from '../aufgaben_verwaltung/AufagbenVerwaltungInternal.vue'
import AufgabenVerwaltungBauhof from '../aufgaben_verwaltung/AufgabenVerwaltungBauhof.vue'
export default {
  name: "AufgabenVerwaltungRouter",
  components: {AufgabenVerwaltungInternal, AufgabenVerwaltungBauhof},
  data() {
    return {
      loader: undefined,
      hasBauhofPosteingang: false,
    }
  },
  created() {
    this.showLoader();
    this.$http.get(
        Server_URL+'/auftragsbuch/data/fetch'
    ).then(this.responseOkGet, this.responseError)
  },
  methods: {

    showLoader() {
      this.loader = this.$loading.show();
    },
    hideLoader() {
      if (this.loader !== undefined) {
        this.loader.hide();
        this.loader = undefined;
      }
    },
    responseError(response) {
      this.hideLoader();
      if (response.status === 401) {
        window.location = Redirect_Login;
      } else {
        window.location = Redirect_500;
      }
    },
    responseOkGet(response) {
      this.hideLoader();
      if (response.status === 200 && response.body.status === "ok") {
        this.hasBauhofPosteingang = response.body.data.has_bauhof_posteingang;
        if (!this.hasBauhofPosteingang) {
          this.$nextTick(() => {
            this.$refs.internal.responseOkGet(response);
          });
        } else {
          this.$nextTick(() => {
            this.$refs.bauhof.responseOkGet(response);
          });
        }
      } else {
        window.location = Redirect_500;
      }
    },
  }
}
</script>

<style>

.row {
  flex: initial;
  margin: unset;
  margin-right: -15px;
  margin-left: -15px;
}

.col-xl, .col-xl-auto, .col-xl-12, .col-xl-11, .col-xl-10, .col-xl-9, .col-xl-8, .col-xl-7, .col-xl-6, .col-xl-5, .col-xl-4, .col-xl-3, .col-xl-2, .col-xl-1, .col-lg, .col-lg-auto, .col-lg-12, .col-lg-11, .col-lg-10, .col-lg-9, .col-lg-8, .col-lg-7, .col-lg-6, .col-lg-5, .col-lg-4, .col-lg-3, .col-lg-2, .col-lg-1, .col-md, .col-md-auto, .col-md-12, .col-md-11, .col-md-10, .col-md-9, .col-md-8, .col-md-7, .col-md-6, .col-md-5, .col-md-4, .col-md-3, .col-md-2, .col-md-1, .col-sm, .col-sm-auto, .col-sm-12, .col-sm-11, .col-sm-10, .col-sm-9, .col-sm-8, .col-sm-7, .col-sm-6, .col-sm-5, .col-sm-4, .col-sm-3, .col-sm-2, .col-sm-1, .col, .col-auto, .col-12, .col-11, .col-10, .col-9, .col-8, .col-7, .col-6, .col-5, .col-4, .col-3, .col-2, .col-1 {
  width: 100%;
  padding: unset;
  padding-right: 15px;
  padding-left: 15px;
}

.row + .row {
  margin-top: unset;
}
</style>
